import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./list.module.css";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import { usePlacesWidget } from "react-google-autocomplete";
import { NumericFormat } from "react-number-format";
import { CountryList } from "../../components/Constants";

const AddCompanyForm = ({ setFormOpen, onLocal, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, control, setValue, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      tax_title: "Tax",
      pickup_country: "",
      delivery_country: "",
    },
  });

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("company_address", place.formatted_address);
    },
    options: {
      types: ["address"],
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("company_name", editData?.company_name);
      setValue("company_address", editData?.company_address);
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      setValue("tax_title", editData?.tax_title);
      setValue("pickup_country", editData?.pickup_country);
      setValue("delivery_country", editData?.delivery_country);
      setValue("reference_amount", editData?.reference_amount);

      if (editData?.tax_charges > 0)
        setValue("tax_charges", editData?.tax_charges);
      if (editData?.insurance_charges > 0)
        setValue("insurance_charges", editData?.insurance_charges);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/companies/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          onLocal(response.data.data);
        }

        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/companies", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          onLocal(response.data.data);
        }

        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("company_name", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Company Name*" variant="outlined" />)}
        />
        {errors.company_name && (<span className={`ErrorM`}>{errors?.Company_name?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("company_address", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Company Address*" variant="outlined" inputRef={ref} placeholder=""
          />)}
        />
        {errors.name && (<span className={`ErrorM`}>{errors?.company_address?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("name", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Owner Name*" variant="outlined" />)}
        />
        {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("email", {
            required: "This field is Required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
          render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" disabled={editData} />)}
        />
        {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
      </div>

      {!editData && (<>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("password", {
              required: "This field is Required",
            })}
            control={control}
            render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
          />
          {errors.password && (<span className={`ErrorM`}>{errors?.password?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("conf_password", {
              required: "This field is Required",
              validate: (val) => {
                if (watch("password") !== val) {
                  return "Your passwords do no match";
                }
              },
            })}
            control={control}
            render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
          />
          {errors.conf_password && (<span className={`ErrorM`}>{errors?.conf_password?.message}</span>)}
        </div>
      </>)}

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("phone", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} id="outlined-basic" label="Phone*" variant="outlined" />)}
        />
        {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_title", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Tax Title*" variant="outlined" />)}
        />
        {errors.tax_title && (<span className={`ErrorM`}>{errors?.tax_title?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Tax Charges(%)" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.tax_charges && (<span className={`ErrorM`}>{errors?.tax_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("insurance_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Insurance Charges" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.insurance_charges && (<span className={`ErrorM`}>{errors?.insurance_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Pickup Country*</InputLabel>
          <Controller
            control={control}
            {...register("pickup_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Pickup Country*" {...field}>
              <MenuItem value={"GB"}>United Kingdom</MenuItem>
            </Select>)}
          />
        </FormControl>
        {errors.pickup_country && (<span className={`ErrorM`}>{errors?.pickup_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Delivery Country*</InputLabel>
          <Controller
            control={control}
            {...register("delivery_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Delivery Country*" {...field}>
              {CountryList?.map((i) => {
                return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
              })}
            </Select>)}
          />
        </FormControl>
        {errors.delivery_country && (<span className={`ErrorM`}>{errors?.delivery_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("reference_amount")}
          render={({ field }) => (<NumericFormat {...field} label="Reference Amount" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.reference_amount && (<span className={`ErrorM`}>{errors?.reference_amount?.message}</span>)}
      </div>
    </div>

    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
    </div>
  </form>);
};

export default AddCompanyForm;